export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Bezpieczna strona płatności',
      description: 'Bezpiecznie szyfrujemy Twoje informacje finansowe',
      methodErrorTips: 'Przepraszamy, wybrany przez Ciebie kraj nie jest obecnie obsługiwany. Proszę wybrać inny kraj i spróbować ponownie.',
      recommendation: 'Rekomendacja',
      cardNumber: 'Numer karty',
      cardName: 'Nazwa na karcie',
      cvv: 'CVV',
      expiredDate: 'Data ważności',
      billingInfo: 'Informacje rozliczeniowe',
      country: 'Kraj',
      state: 'Stan',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      document: 'Dokument',
      city: 'Miasto',
      address: 'Adres',
      streetNumber: 'Numer ulicy',
      zipCode: 'Kod pocztowy',
      email: 'E-mail',
      phone: 'Numer telefonu',
      pay: 'PŁAĆ',
      choosePaymentMethod: 'Wybierz metodę płatności',
      continue: 'Kontynuuj',
      later: 'Później',
      returnToMerchant: 'Anuluj i wróć do sprzedawcy',
      resultToMerchant: 'Wróć do sprzedawcy',
      orderId: 'ID zamówienia',
      orderAmount: 'Kwota zamówienia',
      billingDescriptor: 'Opis faktury',
      goodsName: 'Nazwa towaru',
      timeLimit: 'Proszę zakończyć płatność w wyznaczonym czasie, w przeciwnym razie strona zostanie zamknięta',
      otherPaymentMethods: 'Inne metody płatności',
      close: 'Zamknij',
      paymentErrorTitle: 'Płatność nie powiodła się',
      paymentErrorTip: 'Twoja płatność nie została pomyślnie przetworzona. Proszę spróbować ponownie.',
      paymentFailed: 'Proces płatności nie powiódł się',
      continueShopping: 'Kontynuuj zakupy',
      paymentSuccess: 'Proces płatności zakończony pomyślnie',
      paymentPending: 'Płatność wysłana, potwierdzenie',
      correctDateTip: 'Proszę wprowadzić ważną datę wygaśnięcia',
      correctCardNumberTip: 'Proszę wprowadzić ważny numer karty',
      correctSecurityCodeTip: 'Proszę wprowadzić prawidłowy kod zabezpieczający',
      mobileMoneyOperator: 'Operator pieniędzy mobilnych',
      bank: 'Bank',
      correctEmailAddressTip: 'Wprowadź poprawny adres e-mail',
      notSupportPaymentTip: ' Bieżące środowisko nie obsługuje płatności {type}',
      addValidPaymentCard: 'Proszę dodać ważną kartę płatniczą',
      timeLimitTip: 'Opłata zostanie pobrana 12 godzin przed końcem okresu próbnego (<span class="date">{date}</span>), następnie subskrypcja będzie odnawiana co <span class="date">{month}</span> miesięcy w kwocie <span class="amount"> {amount} {currency}</span>, można anulować w dowolnym momencie',
      product: 'Produkt/Usługa',
      subscribeType: 'Typ subskrypcji',
      renewCycle: 'Cykl odnawiania',
      renewAmount: 'Kwota odnawiania',
      subscribePay: 'Subskrybuj i zapłać',
      readAgreement: "Przeczytaj i zaakceptuj <span class='protocol-link' style='color: #31a7da;'>Umowę o automatycznym odnawianiu</span>",
      depict: 'Opis',
      copyQrCode: 'Kopiuj QR-Code',
      copySuccess: 'Kopiuj pomyślnie',
      copyError: 'Kopiuj nie pomyślnie',
      refreshQrCode: 'Odualizuj QR-Code'
    },
    subscribe: {
      yourSubscribe: 'Twoja subskrypcja',
      unsubscribeTip: 'Aby anulować, kliknij przycisk [Anuluj subskrypcję] na dole strony.',
      renewTip: 'Pobierzemy opłatę <span class="amount"> {amount} {currency}</span> w dniu <span class="date">{date}</span>, możesz anulować w dowolnym momencie',
      unsubscribe: 'Anuluj subskrypcję',
      autoRenew: 'Umowa o automatycznym odnawianiu',
      unsubscribeTipTwo: 'Jeśli anulujesz teraz, nadal będziesz mógł korzystać z tej subskrypcji do <span class="date">{date}</span>.',
      emailVerifyTip: 'Weryfikacja e-mail',
      inputCodeTip: 'Proszę wprowadzić kod weryfikacyjny',
      sendSuccessTip: 'Kod weryfikacyjny wysłany pomyślnie',
      sendErrorTip: 'Nie udało się wysłać kodu weryfikacyjnego',
      unsubscribeSuccessTip: 'Subskrypcja anulowana pomyślnie',
      unsubscribeErrorTip: 'Nie udało się anulować subskrypcji',
      sendCodeTip: 'Wyślij ponownie za {code} sekund',
      sendEmailTip: 'Uzyskaj kod weryfikacyjny',
      daily: 'Co dzień',
      weekly: 'Co 7 dni',
      monthly: 'Co 30 dni',
      quarterly: 'Co 90 dni',
      semiAnnually: 'Co 180 dni',
      annually: 'Co 365 dni',
      regularRenewal: 'Regularne odnawianie',
      oneTime: 'Jednorazowo',
      inputNumberTip: 'Proszę wprowadzić tylko cyfry',
      eachCalendarMonth: 'Co miesiąc kalendarzowy'
    },
    common: {
      confirm: 'Potwierdzaj',
      cancel: 'Anuluj',
      uploadImgErrorTip: 'Można przesyłać tylko obrazy',
      inputMessageTip: 'Proszę wypełnić treść',
      sendSuccessTip: 'Wysłanie powiodło się',
      sendErrorTip: 'Wysłanie nie powiodło się',
      inputPlaceholder: 'Proszę wprowadzić {field}',
      selectPlaceholder: 'Proszę wybrać {field}',
      correctFormat: 'Wprowadź prawidłowy format, na przykład: {example}'
    }
  }
}
